import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';
import { staticImageAssets } from 'js/constants/Paths';

// import actions
import { fetchGalleryData, toggleDisplayEntry } from 'js/store/gallery/Gallery.actions';

// import svg
import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';
import ArtworkSubmissionForm from 'js/components/form/Form.gallery-submission';
import FilterGridIndex from 'js/components/filter-grid/FilterGrid.index';
import GalleryModal from 'js/components/gallery/Gallery.modal';
import ButtonScrollToForm from 'js/components/button/Button.scroll-to-form';

// import selectors
import { getSiteMetaData, getCurrentPageData } from 'js/store/app/App.selectors';
import { hasFetchedGalleryData } from 'js/store/gallery/Gallery.selectors';

import HeaderRegionEntries from 'js/containers/header-region/HeaderRegion.entries';

const PageGallery = (props) => {
  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.gallery]);
  });

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, PAGE_IDS.gallery);
  });

  const dispatch = useDispatch();
  const hasFetched = useSelector((state) => {
    return hasFetchedGalleryData(state);
  });

  useEffect(() => {
    !hasFetched && dispatch(fetchGalleryData());

    trackPageview({ title: 'gallery', path: props.path });

    return () => {
      dispatch(toggleDisplayEntry(false));
    };
  }, []);

  const { header = {}, body = {} } = pageData;

  return (
    <>
      <GalleryModal />
      <SiteMetaData {...meta} />
      {hasFetched && (
        <HeaderRegionEntries
          title={header?.title || 'Submit Your Artwork'}
          description={
            header?.description ||
            'Get creative and share a brilliant picture you have made. It could appear on this website - or even Milkshake!'
          }
        />
      )}

      <div className="gallery-page" style={{ backgroundColor: '#FC91C2', paddingTop: '150px' }}>
        <SvgTextureLineLong color={'#FC91C2'} />
        <div className="container">
          {hasFetched ? <FilterGridIndex title="The Gallery" type={'gallery'} /> : <p>Loading...</p>}
        </div>
      </div>
      <div
        className="gallery-page gallery-page--submission"
        style={{ backgroundColor: '#936888', paddingBottom: '100px' }}
      >
        <SvgTextureLineLong color={'#936888'} />
        <div className="container">
          <div className="artwork-form">
            <h1 className="gallery-page__title">Submit Your Own Artwork</h1>
            <h2>We want your awesome pictures!</h2>
            <p>
              Have you created an excellent picture? Then we'd love to see it! It could be a drawing of Stan, a painting
              of Gran, or even a collage of your favourite animal from the show. Just grab your grown-up and ask them to
              help you upload your masterpiece below.
            </p>
            <h3>Submission guides</h3>
            <p>
              When you are creating your fabulous artwork, try to use an A4 sheet of paper. Or if that's too big for
              you, try folding it in half.
            </p>
            <ButtonScrollToForm />
            <ArtworkSubmissionForm />
          </div>
        </div>
      </div>
    </>
  );
};

export default PageGallery;
